<!-- Main content Start -->
<div class="main-content">
  <!--Full width header Start-->
  <div class="full-width-header home8-style4 home9">
    <home-main-menu></home-main-menu>
  </div>
  <!--Full width header End-->
  <!-- Slider Section Start -->
  <div class="rs-slider main-home">
    <div class="rs-carousel owl-carousel" data-loop="true" data-items="1" data-margin="0" data-autoplay="true" data-hoverpause="true" data-autoplay-timeout="5000" data-smart-speed="800" data-dots="false" data-nav="true" data-nav-speed="false" data-center-mode="false" data-mobile-device="1" data-mobile-device-nav="false" data-mobile-device-dots="false" data-ipad-device="1" data-ipad-device-nav="false" data-ipad-device-dots="false" data-ipad-device2="1" data-ipad-device-nav2="false" data-ipad-device-dots2="false" data-md-device="1" data-md-device-nav="true" data-md-device-dots="false">

      <div class="slider-content slide1" style="background-image: url('assets/college/sbesbanner.jpg'); background-size: cover; background-position: center center; background-repeat: no-repeat; min-height: 620px;">
        <div class="container">
        </div>
      </div>

      <div class="slider-content slide2" style="background-image: url('assets/college/sbesbanner2.jpg'); background-size: cover; background-position: center center; background-repeat: no-repeat; min-height: 620px;">
        <div class="container">
        </div>
      </div>

      <div class="slider-content slide3" style="background-image: url('assets/college/sbesbanner.jpg'); background-size: cover; background-position: center center; background-repeat: no-repeat; min-height: 620px;">
        <div class="container">
        </div>
      </div>
    </div>

    <!-- Features Section start -->
    <div id="rs-features" class="rs-features main-home">
      <div class="container">
        <div class="row">
          <div class="col-lg-4 col-md-12 md-mb-30">

          </div>
          <div class="col-lg-4 col-md-12 md-mb-30">

          </div>
          <div class="col-lg-4 col-md-12">

          </div>
        </div>
      </div>
    </div>
    <!-- Features Section End -->
  </div>
  <!-- Slider Section End -->
  <!-- CTA Section Start -->
  <div class="rs-cta main-home">
    <div class="partition-bg-wrap">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <a href="#"><img src="assets/college/sbeslogo.png" alt=""></a>
          </div>
          <div class="col-lg-6 pl-70 md-pl-15">
            <div class="sec-title3 mb-40">
              <h2 class="title white-color mb-16">
                Welcome To
                Sri Balaji Educational Society
              </h2>
              <div class="desc white-color pr-100 md-pr-0">
                Sri Balaji Educational Society, (Regd. No: 330 of 199, Dated 02-11-2019) is setup as a brainchild of Sri. Dr. Palle Raghunatha Reddy in the year 1991, with the motto of providing better education and creating intellectually gifted individuals from all colleges run under the society.

              </div>
            </div>
            <div class="btn-part">
              <a class="readon orange-btn transparent" routerLink="/about/sri-balaji-educational-society">
                Read More
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- CTA Section End -->
  <!-- Faq Section Start -->
  <div class="rs-faq-part style1 orange-color pt-100 pb-100 md-pt-70 md-pb-70">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 rs-faq-part style1 orange-color">
          <div class=" main-part">
            <div class="title mb-40 md-mb-15">
              <h2 class="text-part">Frequently Asked Questions</h2>
            </div>
            <div class="faq-content">
              <div id="accordion" class="accordion">
                <div class="card">
                  <div class="card-header">
                    <a class="card-link" data-toggle="collapse" href="#collapseOne">
                      When was the educational society established?
                    </a>
                  </div>
                  <div id="collapseOne" class="collapse show" data-parent="#accordion">
                    <div class="card-body">
                      The Educational society was established in the year 1991.
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header">

                    <a class="card-link collapsed" data-toggle="collapse" href="#collapseTwo" aria-expanded="false">
                      Who were founding members of the educational society?
                    </a>
                  </div>
                  <div id="collapseTwo" class="collapse" data-parent="#accordion" style="">
                    <div class="card-body">
                      Dr. Palle Raghunatha Reddy and Smt. Palle Uma.
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header">

                    <a class="card-link collapsed" data-toggle="collapse" href="#collapseThree" aria-expanded="false">
                      What Kind of courses do we offer for 12A eligible under our educational society?
                    </a>
                  </div>
                  <div id="collapseThree" class="collapse" data-parent="#accordion" style="">
                    <div class="card-body">
                      We offer a wide variety of disciplines through 40 + independent institutes.
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header">

                    <a class="card-link collapsed" data-toggle="collapse" href="#collapsefour" aria-expanded="false">
                      Whare are all of colleges located?
                    </a>
                  </div>
                  <div id="collapsefour" class="collapse" data-parent="#accordion" style="">
                    <div class="card-body">
                      With over 15+ campuses, we are located all over Anantapur District. Please check "our College locations" tab in the menu above to view colleges by location.
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header">
                    <a class="card-link collapsed" data-toggle="collapse" href="#collapsefive" aria-expanded="false">
                      How do I contact top level management?
                    </a>
                  </div>
                  <div id="collapsefive" class="collapse" data-parent="#accordion" style="">
                    <div class="card-body">
                      You can email the chairman at <a href="mailto:chairman@sbesatp.org">Chairman@sbesatp.org</a>
                      <p>For generic questions, please reach us through <a routerLink="/contact">Contact Us</a> page.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 padding-0">
          <div class="img-part media-icon orange-color">
            <a class="play-btn-link" href="https://www.youtube.com/@sribalajieducationalsociet1772" target="_blank" rel="noopener noreferrer">
              <i class="fa fa-play"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- faq Section Start -->
  <!-- Testimonial Section Start -->
  <!-- Testimonial Section End -->
  <!-- Blog Section Start -->

</div>
<!-- Categories Section Start -->



<!-- Categories Section End -->
<div id="rs-team" class="rs-team style1 inner-style orange-color pt-94 pb-100 md-pt-64 md-pb-70 gray-bg">
  <div class="container">
    <div class="sec-title mb-50 md-mb-30 text-center">
      <div class="sub-title orange">Instructor</div>
      <h2 class="title mb-0">Committee Members</h2>
    </div>
    <div class="row">
      <div class="col-lg-4 col-sm-6 mb-30">
        <div class="team-item">
          <a href="#"><img src="https://jntuanotifications.blob.core.windows.net/websites/profiles/Dr_Palle_Raghunatha_Reddy.png" alt=""></a>

          <div class="content-part">
            <h4 class="name"><a routerLink="/about/founder">Dr.Palle Raghunatha Reddy</a></h4>          
            <span class="designation">
              Founder, Correspondent & Secretary<br />
              Sri Balaji Educational Society
            </span>
            <ul class="social-links">
              <li><a href="https://www.facebook.com/palleraghunathreddy.puttaparthi"><i class="fa fa-facebook"></i></a></li>
              <li><a href="https://x.com/palleraghu_tdp?s=20&t=qjj89OWdeoNrM_-p-b6o5A"><i class="fa fa-twitter"></i></a></li>
              <li><a href="#"><i class="fa fa-linkedin"></i></a></li>
              <li><a href="#"><i class="fa fa-google-plus"></i></a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-sm-6 mb-30">
        <div class="team-item">
          <a href="#"><img src="https://jntuanotifications.blob.core.windows.net/websites/profiles/Dr_Palle_Venkata_Krishna_Kishore.png" alt=""></a>

          <div class="content-part">
            <h4 class="name"><a routerLink="/about/chairman">Dr.Palle Venkata Krishna Kishore Reddy</a></h4>
            <span class="designation">
              Chairman<br />
              Sri Balaji Educational Society
            </span>
            <ul class="social-links">
              <li><a href="https://www.facebook.com/kishore.palle.33"><i class="fa fa-facebook"></i></a></li>
              <li><a href="#"><i class="fa fa-twitter"></i></a></li>
              <li><a href="#"><i class="fa fa-linkedin"></i></a></li>
              <li><a href="https://www.instagram.com/kishorerpalle/followers/mutualOnly"><i class="fa fa-instagram"></i></a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-sm-6 mb-30">
        <div class="team-item">
          <a href="#"><img src="https://jntuanotifications.blob.core.windows.net/websites/profiles/Smt_Palle_Sindhura_Reddy.png" alt=""> </a>

          <div class="content-part">
            <h4 class="name"><a routerLink="/about/treasurer">Smt.Palle Sindhura Reddy</a></h4>
            <span class="designation">
              Treasurer,
              Sri Balaji Educational Society<br />
              MLA, Puttaparthi Constituency, AP
            </span>
            <ul class="social-links">
              <li><a href="https://www.facebook.com/pallesindhurareddy?mibextid=ZbWKwL"><i class="fa fa-facebook"></i></a></li>
              <li><a href="#"><i class="fa fa-twitter"></i></a></li>
              <li><a href="#"><i class="fa fa-linkedin"></i></a></li>
              <li><a href="https://www.instagram.com/pallesindhurareddy/"><i class="fa fa-instagram"></i></a></li>
            </ul>
          </div>
        </div>
      </div>
     
    </div>
  </div>
</div>
<!-- Blog Section End -->
<!-- Newsletter section start -->
<app-subscribe></app-subscribe>
<!-- Newsletter section end -->
<!-- Main content End -->
